import { DatePickerWUT } from '@wix/form-fields/viewer-wut';

export default DatePickerWUT;
